import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, put } from 'redux-saga/effects';

import { usersFetch } from './users';

type Payload = {
  metadata: Record<string, unknown>;
  username: string;
  companyId: string;
};

export const usersAddMetadata = createApiSlice<unknown, Payload>({
  name: 'usersAddMetadata',
  *tryGenerator(_, { payload: { metadata, username, companyId } }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/auth/user/:username/metadata', urlParams: { username } }),
      data: metadata,
    });

    yield put(usersFetch.actions.call({ companyId }));

    return null;
  },
});
